import angular from "angular";
import "angular-pageslide-directive";

export default angular
  .module("controllers.application", [
    "pageslide-directive",
  ])
  .controller("ApplicationController", [
    "$window",
    "$scope",
    function($window, $scope) {
      var vm = this;

      vm.isMenuOpen = false;
      vm.isMobile = $window.innerWidth <= 768; // breakpoint

      vm.toggleMenu = function() {
        vm.isMenuOpen = !vm.isMenuOpen;
      };

      // Atualiza em resize
      angular.element($window).on("resize", function() {
        $scope.$apply(function() {
          vm.isMobile = $window.innerWidth <= 768;
        });
      });
    },
  ])
  .name;


// WEBPACK FOOTER //
// ./app/web/packs/angular/controllers/application-controller.js